'use strict'

import React from 'react';
import { OnSchedRest } from '../../../../OnSchedRest';
import { OnSchedUtils } from '../../../../utils';


const FormLoadedDropdown = (e) => {
  const [data, setData] = React.useState([]);

  const colorClasses = 'onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover';

  // Get results from API
  React.useEffect(() => {
    const baseUrl = e.interface === "consumer" ? e.element.onsched.apiBaseUrl : e.element.onsched.setupApiBaseUrl
    const url = baseUrl + '/' + e.childKey;

    OnSchedRest.Get(url, response => {
      if (response.error) {
        // Throw error
      }
      else {
        // Set results to onschedState
        OnSchedUtils.SetState(e.onschedState, e.childKey, response);
        let newData = response;
        if (e.responseKey) {
          newData = response[e.responseKey];
        }
        // Set results to local state
        setData(newData);
      }
    })
  }, []);

  return (
    <div
      className={`${colorClasses} ${e.className ? e.className : ''} a FormInput FormDropdown`} 
      label={e.label}
      tooltip="lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar "
    >
      <select 
        name={e.name}
        className='onsched-primary-border-color-active onsched-primary-border-color-focus'
      >
        {e.placeholder && <option value="" disabled="disabled">{e.placeholder}</option>}
        { data.map((d, idx) => <option key={idx} data-id={d.id} data-location-id={d.locationId} value={d.value}>{d.name}</option>) }
      </select>
    </div>
  )
}

export default FormLoadedDropdown
